import { ArrowDownCircle, ArrowUpCircle } from 'lucide-react';

export const fmtVES = (n) => `VES ${Number(n || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleString('es-VE', { dateStyle: 'short', timeStyle: 'short' }) : '—');

export const ENTRY_TYPES = {
  payment_in: { label: 'Pago recibido', bg: 'bg-green-100', text: 'text-green-800' },
  bank_fee: { label: 'Fee banco', bg: 'bg-orange-100', text: 'text-orange-800' },
  caurapay_fee: { label: 'Comisión CauraPay', bg: 'bg-blue-100', text: 'text-blue-800' },
  refund: { label: 'Refund', bg: 'bg-red-100', text: 'text-red-800' },
  dispersion: { label: 'Dispersión', bg: 'bg-purple-100', text: 'text-purple-800' },
  adjustment_credit: { label: 'Ajuste (+)', bg: 'bg-emerald-100', text: 'text-emerald-800' },
  adjustment_debit: { label: 'Ajuste (−)', bg: 'bg-rose-100', text: 'text-rose-800' },
};

export const EntryTypeBadge = ({ type }) => {
  const t = ENTRY_TYPES[type] || { label: type, bg: 'bg-gray-100', text: 'text-gray-700' };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${t.bg} ${t.text}`}>{t.label}</span>;
};

export default function LedgerStatementTable({ entries, emptyMessage = 'Sin movimientos registrados' }) {
  if (!entries || entries.length === 0) {
    return <div className="text-center py-10 text-gray-400" data-testid="ledger-empty">{emptyMessage}</div>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm" data-testid="ledger-statement-table">
        <thead>
          <tr className="text-left text-xs text-gray-500 uppercase border-b">
            <th className="py-2.5 pr-4">Fecha</th>
            <th className="py-2.5 pr-4">Tipo</th>
            <th className="py-2.5 pr-4">Descripción</th>
            <th className="py-2.5 pr-4">Referencia</th>
            <th className="py-2.5 pr-4 text-right">Crédito</th>
            <th className="py-2.5 pr-4 text-right">Débito</th>
            <th className="py-2.5 text-right">Saldo</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr key={e.entry_id} className="border-b border-gray-50 hover:bg-gray-50" data-testid={`ledger-entry-${e.entry_id}`}>
              <td className="py-2.5 pr-4 whitespace-nowrap text-gray-600">{fmtDate(e.created_at)}</td>
              <td className="py-2.5 pr-4"><EntryTypeBadge type={e.entry_type} /></td>
              <td className="py-2.5 pr-4 text-gray-700 max-w-md truncate" title={e.description}>{e.description}</td>
              <td className="py-2.5 pr-4 text-gray-500 font-mono text-xs">{e.bank_reference || '—'}</td>
              <td className="py-2.5 pr-4 text-right">
                {e.direction === 'credit' ? (
                  <span className="text-green-700 font-semibold inline-flex items-center gap-1">
                    <ArrowUpCircle className="w-3.5 h-3.5" />{fmtVES(e.amount)}
                  </span>
                ) : '—'}
              </td>
              <td className="py-2.5 pr-4 text-right">
                {e.direction === 'debit' ? (
                  <span className="text-red-600 font-semibold inline-flex items-center gap-1">
                    <ArrowDownCircle className="w-3.5 h-3.5" />{fmtVES(e.amount)}
                  </span>
                ) : '—'}
              </td>
              <td className="py-2.5 text-right font-mono font-semibold text-gray-900">{fmtVES(e.balance_after)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
